module.exports = __webpack_public_path__ + "static/media/Arial-Rounded-MT-Light.473aee04.svg";